<template>
  <dev-placeholder/>
</template>

<script>
  import DevPlaceholder from '../../../../helpers/TheDevPlaceholder.vue'
  export default {
    name: '',
    components: {
      DevPlaceholder
    },
    data () {
      return {}
    },
    methods: {}
  }
</script>